import { useState } from "react";
import toast from "react-hot-toast";
import axios from "axios";
import { baseApiURL } from "../../../baseUrl";
import { FiSearch, FiUpload, FiX } from "react-icons/fi";
import { getFileUrl } from "../../../utils/fileUrl";

const EditAdmin = () => {
  const [file, setFile] = useState();
  const [searchActive, setSearchActive] = useState(false);
  const [data, setData] = useState({
    employeeId: "",
    firstName: "",
    middleName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    gender: "",
    profile: "",
  });
  const [id, setId] = useState();
  const [search, setSearch] = useState();
  const [previewImage, setPreviewImage] = useState("");

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    setFile(selectedFile);
    const imageUrl = URL.createObjectURL(selectedFile);
    setPreviewImage(imageUrl);
  };

  const updateAdminProfile = (e) => {
    e.preventDefault();
    toast.loading("Updating Admin");
    const headers = { "Content-Type": "multipart/form-data" };
    const formData = new FormData();
    formData.append("employeeId", data.employeeId);
    formData.append("firstName", data.firstName);
    formData.append("middleName", data.middleName);
    formData.append("lastName", data.lastName);
    formData.append("email", data.email);
    formData.append("phoneNumber", data.phoneNumber);
    formData.append("gender", data.gender);
    if (file) {
      formData.append("type", "profile");
      formData.append("profile", file);
    }
    axios
      .put(`${baseApiURL()}/admin/details/updateDetails/${id}`, formData, { headers })
      .then((response) => {
        toast.dismiss();
        if (response.data.success) {
          toast.success(response.data.message);
          clearSearchHandler();
        } else {
          toast.error(response.data.message);
        }
      })
      .catch((error) => {
        toast.dismiss();
        toast.error(error.response.data.message);
      });
  };

  const searchAdminHandler = (e) => {
    setSearchActive(true);
    e.preventDefault();
    toast.loading("Getting Admin");
    const headers = { "Content-Type": "application/json" };
    axios
      .post(`${baseApiURL()}/admin/details/getDetails`, { employeeId: search }, { headers })
      .then((response) => {
        toast.dismiss();
        if (response.data.success) {
          if (response.data.user.length !== 0) {
            toast.success(response.data.message);
            setId(response.data.user[0]._id);
            setData({
              employeeId: response.data.user[0].employeeId,
              firstName: response.data.user[0].firstName,
              middleName: response.data.user[0].middleName,
              lastName: response.data.user[0].lastName,
              email: response.data.user[0].email,
              phoneNumber: response.data.user[0].phoneNumber,
              gender: response.data.user[0].gender,
              profile: response.data.user[0].profile,
            });
          } else {
            toast.dismiss();
            toast.error("No Admin Found With ID");
          }
        } else {
          toast.error(response.data.message);
        }
      })
      .catch((error) => {
        toast.dismiss();
        toast.error(error.response.data.message);
      });
  };

  const clearSearchHandler = () => {
    setSearchActive(false);
    setSearch("");
    setId("");
    setPreviewImage();
    setData({
      employeeId: "",
      firstName: "",
      middleName: "",
      lastName: "",
      email: "",
      phoneNumber: "",
      gender: "",
      profile: "",
    });
  };

  return (
    <div className="space-y-6">
      <div className="bento-header-banner flex items-center justify-between">
        <div>
          <h1 className="text-xl font-bold tracking-tight text-slate-900 dark:text-white">Edit Admin</h1>
          <p className="text-slate-500 dark:text-slate-400 font-medium text-xs mt-0.5">Search by employee ID to update administrator details</p>
        </div>
      </div>

      <div className="bg-white dark:bg-slate-900 rounded-2xl shadow-xs border border-slate-200 dark:border-slate-800 p-6 space-y-6">
        <form
          onSubmit={searchAdminHandler}
          className="flex items-center gap-2 max-w-md mx-auto"
        >
          <div className="relative flex-1">
            <FiSearch className="absolute left-3.5 top-1/2 transform -translate-y-1/2 text-slate-400 w-4 h-4" />
            <input
              type="text"
              className="w-full pl-10 pr-4 py-2.5 bg-slate-50 dark:bg-slate-950 border border-slate-200 dark:border-slate-800 rounded-xl text-slate-900 dark:text-white text-xs font-semibold focus:ring-2 focus:ring-indigo-500 outline-none"
              placeholder="Enter Employee ID"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
          {!searchActive ? (
            <button className="px-4 py-2.5 bg-indigo-600 hover:bg-indigo-500 text-white rounded-xl text-xs font-bold transition shadow-xs cursor-pointer" type="submit">
              Search
            </button>
          ) : (
            <button
              className="px-4 py-2.5 bg-slate-100 dark:bg-slate-800 hover:bg-rose-50 dark:hover:bg-rose-950/60 text-slate-700 dark:text-slate-300 hover:text-rose-600 dark:hover:text-rose-400 rounded-xl text-xs font-bold transition border border-slate-200 dark:border-slate-700 cursor-pointer flex items-center gap-1"
              onClick={clearSearchHandler}
              type="button"
            >
              <FiX /> Clear
            </button>
          )}
        </form>

        {search && id && (
          <form
            onSubmit={updateAdminProfile}
            className="space-y-6 pt-6 border-t border-slate-100 dark:border-slate-800"
          >
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {["firstName", "middleName", "lastName", "employeeId", "email", "phoneNumber"].map((field) => (
                <div key={field}>
                  <label htmlFor={field} className="block text-xs font-semibold text-slate-700 dark:text-slate-300 mb-1.5">
                    {field.replace(/([A-Z])/g, " $1").replace(/^./, (str) => str.toUpperCase())}
                  </label>
                  <input
                    type={field === "email" ? "email" : field === "phoneNumber" || field === "employeeId" ? "text" : "text"}
                    id={field}
                    value={data[field]}
                    onChange={(e) => setData({ ...data, [field]: e.target.value })}
                    className="w-full px-3.5 py-2.5 bg-slate-50 dark:bg-slate-950 border border-slate-200 dark:border-slate-800 rounded-xl text-slate-900 dark:text-white text-xs font-medium focus:ring-2 focus:ring-indigo-500 outline-none"
                  />
                </div>
              ))}

              <div>
                <label htmlFor="gender" className="block text-xs font-semibold text-slate-700 dark:text-slate-300 mb-1.5">
                  Select Gender
                </label>
                <select
                  id="gender"
                  className="w-full px-3.5 py-2.5 bg-slate-50 dark:bg-slate-950 border border-slate-200 dark:border-slate-800 rounded-xl text-slate-900 dark:text-white text-xs font-medium focus:ring-2 focus:ring-indigo-500 outline-none"
                  value={data.gender}
                  onChange={(e) => setData({ ...data, gender: e.target.value })}
                >
                  <option value="" disabled>
                    -- Select Gender --
                  </option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                </select>
              </div>

              <div>
                <label htmlFor="file" className="block text-xs font-semibold text-slate-700 dark:text-slate-300 mb-1.5">
                  Upload Profile Picture
                </label>
                <label
                  htmlFor="file"
                  className="w-full px-3.5 py-2.5 bg-slate-50 dark:bg-slate-950 border border-slate-200 dark:border-slate-800 rounded-xl flex items-center justify-center cursor-pointer transition hover:bg-slate-100 dark:hover:bg-slate-800 text-xs font-semibold text-slate-700 dark:text-slate-300"
                >
                  Upload Photo
                  <FiUpload className="ml-2" />
                </label>
                <input hidden type="file" id="file" accept="image/*" onChange={handleFileChange} />
              </div>
            </div>

            {previewImage && (
              <div className="flex justify-center items-center pt-2">
                <img src={previewImage} alt="Profile Preview" className="h-24 w-24 rounded-2xl object-cover border border-slate-200 dark:border-slate-700 shadow-xs" />
              </div>
            )}

            {!previewImage && data.profile && (
              <div className="flex justify-center items-center pt-2">
                <img
                  src={getFileUrl(data.profile)}
                  alt="Current Profile"
                  className="h-24 w-24 rounded-2xl object-cover border border-slate-200 dark:border-slate-700 shadow-xs"
                />
              </div>
            )}

            <div className="flex justify-end pt-4 border-t border-slate-100 dark:border-slate-800">
              <button
                type="submit"
                className="px-6 py-2.5 bg-indigo-600 hover:bg-indigo-500 text-white rounded-xl text-xs font-bold shadow-xs transition cursor-pointer"
              >
                Update Admin
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default EditAdmin;
